import React from 'react';
import { Modal } from '@domain-group/fe-co-allhomes-design-system';
import * as styles from './btr-info-message.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var WhatIsBTRModal = _ref => {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose;
  return ___EmotionJSX(Modal, {
    mobileStyle: "75perc",
    show: isOpen,
    onClose: onClose,
    title: ___EmotionJSX("div", null, "What is Build-to-Rent?")
  }, ___EmotionJSX("div", {
    css: styles.btrModalContents
  }, ___EmotionJSX("div", {
    css: styles.btrModalSection
  }, "Build-to-Rent properties may offer a more stable lease than other rentals, because they are not intended to be individually sold. They may also come with great amenities and services, making them a turn-key opportunity, whilst giving tenants more housing choices."), ___EmotionJSX("div", {
    css: styles.btrModalSection
  }, "Each property is different, but depending on the address, you may find amenities such as:"), ___EmotionJSX("ul", {
    css: styles.btrModalSectionVP
  }, ___EmotionJSX("li", null, "On-site residence manager, maintenance or utility assistance"), ___EmotionJSX("li", null, "Swimming pool, spa, sauna, gym or fitness centre"), ___EmotionJSX("li", null, "Dog park, shared garden or rooftop"), ___EmotionJSX("li", null, "Movie theatre, media room or co-working space"), ___EmotionJSX("li", null, "Bike storage, tools, etc."))));
};